import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'signature-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class SignatureHomePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
